import BaseModel from '@/store/models/BaseModel';

export default class Service extends BaseModel {}
